import React from 'react';
/** import third-party libraries in the section above, Sort Lines Ascending */

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
/** import mui components in the section above, Sort Lines Ascending */

import { getWeatherConditionFieldLabels } from 'states/resources/weather-conditions/selectors';
/** import single application imports in the section above, Sort Lines Ascending */

/**
 * Horizontal weather field columns for ad summary and creative rotation summary.
 *
 * @param {Object} props
 * @param {Object} props.condition - Weather condition row data
 * @param {Object} props.weatherConditionsData - Bound selector fns
 */
export const WeatherConditionFieldsGrid = ({ condition, weatherConditionsData }) => {
    const {
        conditionLabel,
        qualifierLabel,
        valueLabel,
        timeframeLabel,
    } = getWeatherConditionFieldLabels(condition, weatherConditionsData);

    return (
        <Grid container spacing={2}>
            <Grid item>
                <Typography variant="subtitle2">Condition</Typography>
                <Typography variant="body2">{conditionLabel}</Typography>
            </Grid>
            <Grid item>
                <Typography variant="subtitle2">Qualifier</Typography>
                <Typography variant="body2">{qualifierLabel}</Typography>
            </Grid>
            <Grid item>
                <Typography variant="subtitle2">Value</Typography>
                <Typography variant="body2">{valueLabel}</Typography>
            </Grid>
            <Grid item>
                <Typography variant="subtitle2">Time Frame</Typography>
                <Typography variant="body2">{timeframeLabel}</Typography>
            </Grid>
        </Grid>
    );
};
